// @deprecated, use @enums/event.ts
export const OFFER_EVENT = {
  // Received when a slider have to appear
  SLIDER_SHOW: 'slider-show',
  // Received after deleting a favorite
  FAVORITE_REMOVE_LOADER: 'favorite-remove-loader',
  // Received after validating a proposal refusal
  PROPOSAL_REMOVE_LOADER: 'proposal-remove-loader',
  // Received after send refused match proposal form
  FAVORITE_OFFER_REMOVE: 'favorite-offer-remove',
  PROPOSAL_OFFER_REMOVE: 'proposal-offer-remove',
  // Received after send refused reasons to back-end
  PROPOSAL_REFUSE: 'proposal-refuse',
};
